import { render, staticRenderFns } from "./CurrencyIcon.vue?vue&type=template&id=75d63375&"
import script from "./CurrencyIcon.vue?vue&type=script&lang=js&"
export * from "./CurrencyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports